import React, { useCallback } from "react";
import "./insUnsavedChanges.scss";
import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { language } from "language/default";
import { useDispatch, useSelector } from "react-redux";
import { closeDialog } from "store/messages-dialog";
import { getDialogCallbacks } from "utils/unsaved-changes/dialogRegistry";
export const InsUnSavedChangesAction = () => {
    const { callbackId } = useSelector((state) => state.messagesDialog?.customProp) || {};
    const dispatch = useDispatch();
    const cb = callbackId ? getDialogCallbacks(callbackId) : undefined;
    const onCancel = useCallback((event) => {
        event?.stopPropagation();
        cb?.onCancelHandler?.();
        dispatch(closeDialog());
    }, [cb, dispatch]);
    const onSave = useCallback(async (event) => {
        event?.stopPropagation();
        await cb?.onSaveHandler?.();
        dispatch(closeDialog());
    }, [cb, dispatch]);
    const onDiscard = useCallback((event) => {
        event?.stopPropagation();
        cb?.onDiscardHandler?.();
        dispatch(closeDialog());
    }, [cb, dispatch]);
    return React.createElement("div", { slot: "custom-footer", className: "un-saved-actions" },
        React.createElement(AuxButton, { type: AuxButtonTypeEnum.SECONDARY, onClick: onCancel, className: "cancel", label: language.en.modal.unSavedChanges.cancel }),
        React.createElement(AuxButton, { type: AuxButtonTypeEnum.PRIMARY, onClick: onSave, className: "save", label: language.en.modal.unSavedChanges.save }),
        React.createElement(AuxButton, { type: AuxButtonTypeEnum.SECONDARY, onClick: onDiscard, className: "discard", label: language.en.modal.unSavedChanges.discard }));
};
